import React, { useEffect } from 'react';
import moment from 'moment'

// import TextField from '@mui/material/TextField'
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
// import { DatePicker } from '@mui/x-date-pickers/DatePicker'
// import { es } from 'date-fns/locale'

// estilos
// import '../../../assets/style/componentPrincipal.css'
// import '../compras.css'
// import '../../../assets/style/tablesG.css'

import '../VM1/vm1.css'

// componentes
// import { Buscar } from '../../general/buscadorGastos/Buscar';
// import { iniLoadExpensesList } from '../../redux/actions/compras';
// import { ModalProgress } from '../../modals/ModalProgress';
// import { Crear } from '../general/crear/Crear';
// import { ExportarPlanilla } from '../general/exportarPlanilla/ExportarPlanilla';
// import { VerReporte } from '../../general/buscadorGastos/verReporte/VerReporte';
// import { TableList } from '../tableList';

import { useBuy } from '../../../hooks/useBuy'
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';

export const ComprasListaVM1 = () => {

    //const [loading, setLoading] = useState(true)
    const { buys, initGetAllBuy } = useBuy()

    useEffect(() => {
        //setLoading(true)

        const filters = {
            time: 'month',
            text: '',
            fecha_desde: new Date(),
            fecha_hasta: new Date(),
            check_emitida: true,
            check_pagada: true,
            check_anulada: false,
            check_abonado: false,
            check_justificado: false,
            origen: '',
            page: 1,
            rows: 10
        }

        initGetAllBuy(filters)
        //setLoading(false)
    }, [initGetAllBuy])

    // const handleChangeDateDesde = (newValue) => {
    //     setFilters({
    //         ...filters,
    //         fecha_desde: newValue
    //     })
    // }

    // const handleChangeDateHasta = (newValue) => {
    //     console.log(newValue)
    //     setFilters({
    //         ...filters,
    //         fecha_hasta: newValue
    //     })
    // }

    return (
        <div className='container-fluid vm1-container'>
            <h1>Gastos</h1>

            <div className='vm1-links'>
                <Link to="/gastos/pptos">Ver presupuestos</Link>
            </div>

            <h3 className='vm1-title-month'>Septiembre 2024</h3>

            <div className='vm1-container-list'>
                {buys?.length > 0 && buys?.map(item => (
                    <ItemList
                        key={item.id}
                        item={item}
                    />
                ))
                }
            </div>

        </div >
    )
}

const ItemList = ({ item }) => {
    return (
        <div className='d-flex justify-content-between align-items-center vm1-container-list-item'>
            <div>
                <h4 className='vm1-item-text'>{item?.razon_social || '---'}</h4>
                <h5>
                    <span>
                        {moment(item.fecha_emision).format('DD MMM YYYY')}
                    </span>
                    <span> - </span>
                    <span>{item.estado}</span>
                </h5>
            </div>
            <div className="me-1 vm1-monto">
                <NumberFormat
                    value={item.total_compra ? parseFloat(item.total_compra) : 0}
                    displayType={'text'}
                    thousandSeparator={item.separacion_miles}
                    decimalSeparator={item.separacion_decimales}
                    prefix={`${item.simbolo} `}
                    decimalScale={2}
                    fixedDecimalScale={2}
                />
            </div>
        </div>
    )
}